<template>
  <div>
    <main class="pt-20">
      <section
        id="hero-section"
        class="min-h-screen relative flex flex-col"
        style="background: linear-gradient(to top, #e3e3e3, #e5e4e2, #f1f0ef)"
      >
        <div
          id="pulse-container"
          class="absolute inset-0 flex items-center justify-center z-10"
        >
          <svg width="100%" height="100%">
            <circle cx="50%" cy="50%" r="0" fill="#ffffff" stroke="none">
              <animate
                attributeName="r"
                from="0"
                to="100%"
                dur="5s"
                repeatCount="indefinite"
              />
              <animate
                attributeName="opacity"
                values="0;0.3;0"
                dur="5s"
                repeatCount="indefinite"
              />
            </circle>
          </svg>
        </div>
        <div class="pt-10 px-4 sm:px-0 text-center mx-auto max-w-5xl flex-1">
          <h2 class="text-lg font-semibold text-slate-400">Calm Your Racing Mind</h2>
          <div id="hero-text">
            <h1 class="text-7xl sm:text-8xl font-barlow-condensed font-medium text-brand">
              <div class="flex flex-col justify-center items-center sm:block">
                <span id="split-text" class="hero-word pl-4 text-brand-dark">STOP</span>
                <span class="hidden sm:inline mr-5">-</span>
                <span id="split-text" class="hero-word text-brand">BREATHE</span>
                <span class="hidden sm:inline mr-5">-</span>
                <span id="split-text" class="hero-word text-brand-light">BELONG</span>
              </div>
            </h1>
          </div>
          <p class="text-xl sm:text-2xl font-semibold text-brand-dark mt-2 mb-8 max-w-[90%] sm:max-w-2xl mx-auto">
            Every Saturday at Noon EST (9am Pacific) – Join Our Circle & Connect To Yourself
          </p>
        </div>
        <section
          id="featured-desktop"
          class="sm:flex sm:flex-row sm:justify-between max-w-6xl mx-auto"
        >
          <div id="featured-desktop-items" class="hidden sm:flex sm:flex-col">
            <div id="featured-desktop-item" class="p-6 w-full max-w-96">
              <img
                id="featured-desktop-item-icon"
                class="w-10"
                src="~/assets/img/breathwork.svg"
                alt="Breathwork"
              />
              <div>
                <h2
                  id="featured-desktop-item-title"
                  class="text-2xl font-medium text-brand uppercase mt-2 font-barlow-condensed"
                >
                  Breathwork Integration
                </h2>
                <p
                  id="featured-desktop-item-description"
                  class="text-slate-400 font-medium text-md"
                >
                  Anxiety relief in a breath. Learn the 4-7-8 technique at our free
                  meditation.
                </p>
              </div>
            </div>
            <div id="featured-desktop-item" class="p-6 w-full max-w-96">
              <img
                id="featured-desktop-item-icon"
                class="hidden sm:block w-10"
                src="~/assets/img/community.svg"
                alt="Community"
              />
              <div>
                <h2
                  id="featured-desktop-item-title"
                  class="text-2xl font-medium text-brand uppercase mt-2 font-barlow-condensed"
                >
                  Community Aspect
                </h2>
                <p
                  id="featured-desktop-item-description"
                  class="text-slate-400 font-medium text-md"
                >
                  Find your tribe, find your peace. Free meditation circle every Saturday.
                </p>
              </div>
            </div>
          </div>
          <div>
            <img
              src="assets/img/meditationcircle-hero-image.png"
              alt="Breathwork"
              class="w-full h-full object-cover"
            />
          </div>
          <section id="featured-desktop-section" class="hidden sm:flex sm:flex-col">
            <div id="featured-desktop-items" class="p-6 w-full max-w-96 flex flex-col">
              <div id="featured-desktop-item" class="flex flex-col items-end justify-end">
                <img
                  id="featured-desktop-item-icon"
                  class="w-10"
                  src="~/assets/img/transcendental.svg"
                  alt="Transcendental"
                />
                <div>
                  <h2
                    id="featured-desktop-item-title"
                    class="text-2xl font-medium text-brand uppercase mt-2 font-barlow-condensed text-right"
                  >
                    Transcendental Healing
                  </h2>
                  <p
                    id="featured-desktop-item-description"
                    class="text-slate-400 font-medium text-md text-right"
                  >
                    Stress relief and inner peace await. Free transcendental meditation
                    circle.
                  </p>
                </div>
                <div></div>
              </div>
            </div>
            <div
              id="featured-desktop-item"
              class="p-6 w-full max-w-96 flex flex-col items-end justify-end"
            >
              <img
                id="featured-desktop-item-icon"
                class="w-10"
                src="~/assets/img/mindfulness.svg"
                alt="Mindfulness"
              />
              <div>
                <h2
                  id="featured-desktop-item-title"
                  class="text-2xl font-medium text-brand uppercase mt-2 font-barlow-condensed text-right"
                >
                  Mindfulness Focus
                </h2>
                <p
                  id="featured-desktop-item-description"
                  class="text-slate-400 font-medium text-md text-right"
                >
                  Discover the power of presence. Join our free mindfulness meditation
                  sessions.
                </p>
              </div>
            </div>
          </section>
        </section>
        <!-- Newsletter Form in Hero Section -->
        <div
          class="absolute -bottom-[25%] sm:-bottom-[15%] md:-bottom-[12%] lg:-bottom-[10%] left-0 right-0 mx-auto z-20"
        >
          <div class="bg-white shadow-xl rounded-xl p-8 max-w-[90%] sm:max-w-3xl mx-auto">
            <h3 class="text-2xl text-center font-semibold text-brand mb-6">
              Sign Up For Your Weekly Email Reminder
            </h3>
            <NewsletterForm />
          </div>
        </div>
      </section>
      <section
        id="featured-mobile-section"
        class="flex sm:hidden mt-72 mb-16 flex-col items-center justify-between mx-auto px-6"
      >
        <div id="featured-mobile-items" class="flex flex-col gap-8">
          <div id="featured-mobile-item" class="flex flex-row items-center gap-6">
            <img
              id="featured-mobile-item-icon"
              class="w-12"
              src="~/assets/img/breathwork.svg"
              alt="Breathwork"
            />
            <div>
              <h2
                id="featured-mobile-item-title"
                class="text-2xl font-medium text-brand uppercase font-barlow-condensed"
              >
                Breathwork Integration
              </h2>
              <p
                id="featured-mobile-item-description"
                class="text-slate-400 font-medium text-md"
              >
                Anxiety relief in a breath. Learn the 4-7-8 technique at our free
                meditation.
              </p>
            </div>
          </div>
          <div id="featured-mobile-item" class="flex flex-row items-center gap-6">
            <img
              id="featured-mobile-item-icon"
              class="w-12"
              src="~/assets/img/community.svg"
              alt="Community"
            />
            <div>
              <h2
                id="featured-mobile-item-title"
                class="text-2xl font-medium text-brand uppercase font-barlow-condensed"
              >
                Community Aspect
              </h2>
              <p
                id="featured-mobile-item-description"
                class="text-slate-400 font-medium text-md"
              >
                Find your tribe, find your peace. Free meditation circle every Saturday.
              </p>
            </div>
          </div>
          <div id="featured-mobile-item" class="flex flex-row items-center gap-6">
            <img
              id="featured-mobile-item-icon"
              class="w-12"
              src="~/assets/img/transcendental.svg"
              alt="Transcendental"
            />
            <div>
              <h2
                id="featured-mobile-item-title"
                class="text-2xl font-medium text-brand uppercase font-barlow-condensed"
              >
                Transcendental Healing
              </h2>
              <p
                id="featured-mobile-item-description"
                class="text-slate-400 font-medium text-md"
              >
                Stress relief and inner peace await. Free transcendental meditation
                circle.
              </p>
            </div>
          </div>
          <div id="featured-mobile-item" class="flex flex-row items-center gap-6">
            <img
              id="featured-mobile-item-icon"
              class="w-12"
              src="~/assets/img/mindfulness.svg"
              alt="Mindfulness"
            />
            <div>
              <h2
                id="featured-mobile-item-title"
                class="text-2xl font-medium text-brand uppercase font-barlow-condensed"
              >
                Mindfulness Focus
              </h2>
              <p
                id="featured-mobile-item-description"
                class="text-slate-400 font-medium text-md"
              >
                Discover the power of presence. Join our free mindfulness meditation
                sessions.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section id="podcast-section" class="bg-slate-100">
        <div
          class="container mx-auto px-4 sm:px-0 pt-20 sm:pt-32 pb-20 max-w-6xl overflow-hidden">
          <h2 class="text-3xl sm:text-4xl font-bold text-center text-brand mt-2">
            Enjoy A Few Of Our Free Guided Meditations
          </h2>
          <div class="flex flex-col items-center mx-auto w-full max-w-5xl mt-10">
            <div v-if="audios && audios.data.length > 0">
              <PodcastCard v-for="audio in audios.data" :key="audio.id" :audio="audio" />
            </div>
          </div>
          <div class="flex justify-center mt-10">
            <NuxtLink
              to="/meditations"
              id="podcastPageButton"
              class="flex items-center gap-2 bg-brand border border-white text-white font-semibold py-3 px-6 rounded-md shadow-md hover:bg-brand-light transition-colors duration-300"
            >
              <img src="~/assets/img/record-white.svg" alt="Record" class="w-8" />
              Listen to all Meditations
            </NuxtLink>
          </div>
        </div>
      </section>
      <section id="about-section" class="bg-white">
        <div class="container mx-auto pt-10 sm:pt-20 pb-20 max-w-5xl">
          <h2 class="text-3xl sm:text-4xl font-bold text-center text-brand mt-2">
            About Us
          </h2>
          <div class="mt-10 px-4 sm:px-0 w-full">
            <div class="flex flex-col sm:flex-row gap-12">
              <div class="flex flex-col gap-4 w-full sm:w-1/2">
                <div class="flex flex-col gap-4 border-b border-brand pb-3">
                  <h3 class="text-2xl font-bold text-brand mt-2">Meet Your Guides</h3>
                </div>
                <div>
                  <h3 class="text-xl font-semibold text-brand mt-2">Effie Collova</h3>
                  <h4 class="text-base sm:text-lg font-medium text-brand-light mt-2">
                    Artist, Wife, Burner, Alchemist, and Empath
                  </h4>
                  <p
                    class="text-slate-400 text-sm sm:text-md text-justify leading-snug mt-2"
                  >
                    Meditation has been a foundational practice in my journey, enhancing
                    other healing modalities like 5Rhythms, somatic release, breathwork,
                    and ecstatic dance. <br /><br />Through the power of art, stillness,
                    and intentional movement, I've discovered my calling to be of service
                    to others as they navigate their own healing path.<br /><br />My work
                    isn't about fixing or changing anyone, but creating the safety and
                    clarity needed for real transformation. My role is simply to walk
                    beside you, holding space until you're ready to step fully into
                    yourself.
                  </p>
                </div>
                <div class="mt-4">
                  <h3 class="text-xl font-semibold text-brand">Anthony Collova</h3>
                  <h4 class="text-base sm:text-lg font-medium text-brand-light mt-2">
                    Husband, Burner, Artist, Self-Care Coach, and Seeker.
                  </h4>
                  <p
                    class="text-slate-400 text-sm sm:text-md text-justify leading-snug mt-2"
                  >
                    I was first introduced to meditation in 1996 when I took my first
                    steps into a life of sober introspection. As a student and a teacher,
                    I've experienced firsthand how breath, stillness, and inner work can
                    unlock deep healing and transformation.<br /><br />As a Kambo
                    facilitator, breathwork guide, and explorer of expanded states of
                    consciousness, I am passionate about helping mobilize and metabolize
                    stuck energy. Through shadow work, inner child healing, and the
                    alchemy of forgiveness, I help guide others to release what no longer
                    serves them and step into a life of greater peace, clarity, and
                    self-love.
                  </p>
                </div>
              </div>
              <div class="w-full sm:w-1/2 relative flex flex-col justify-start">
                <div class="flex justify-center items-center h-full mb-8">
                  <img
                    src="~/assets/img/anthony-effie.png"
                    alt="Anthony and Effie"
                    class="w-full h-full object-contain"
                  />
                </div>
                <div id="quote-block" class="flex items-center gap-3 h-auto min-h-[6rem]">
                  <div class="h-full">
                    <span
                      class="w-1 h-full bg-brand origin-center inline-block"
                      style="transform: scaleY(0)"
                      :class="{ 'animate-expand': inView }"
                      ref="animatedSpan"
                    ></span>
                  </div>
                  <p
                    id="quote-text"
                    class="text-md font-semibold text-brand flex-1"
                    ref="quoteText"
                  >
                    <span class="quote-line opacity-0 block transform translate-x-[-50px]"
                      >The combined experience of Anthony and Effie provides a</span
                    >
                    <span class="quote-line opacity-0 block transform translate-x-[-50px]"
                      >well-rounded approach to wellness, blending practical</span
                    >
                    <span class="quote-line opacity-0 block transform translate-x-[-50px]"
                      >strategies with spiritual guidance to help you achieve lasting
                      results.</span
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="contact-section" class="bg-white px-4 sm:px-0">
        <div class="container mx-auto pt-20 pb-10 max-w-5xl">
          <h2 class="text-3xl sm:text-4xl font-bold text-center text-brand">
            Let's Connect
          </h2>
        </div>
        <div
          class="container relative flex justify-between p-10 rounded-2xl mx-auto py-10 px-4 sm:px-20 max-w-7xl"
          :style="{
            backgroundImage: `url(${meditationStance})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }"
        >
          <div class="absolute inset-0 bg-black opacity-20 rounded-2xl"></div>
          <div class="w-none sm:w-1/2 relative z-10"></div>
          <div class="relative z-10 w-full sm:w-1/2">
            <div class="pt-2 pb-8 px-8 rounded-2xl bg-brand-dark/60 backdrop-blur">
              <h3
                class="text-2xl sm:text-3xl font-semibold text-white mb-4 text-center mt-4"
              >
                Reach Out & Connect
              </h3>
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
      <section id="faq-section" class="bg-white px-4 sm:px-0">
        <div class="container mx-auto py-20 max-w-5xl">
          <h2 class="text-3xl sm:text-4xl font-bold text-center text-brand">
            Frequently Asked Questions
          </h2>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-10 mt-10">
            <div class="flex flex-col gap-4">
              <details
                v-for="(faq, index) in faqs.slice(0, 7)"
                :key="`faq-left-${index}`"
                class="text-base sm:text-md p-4 border-b flex flex-col justify-between items-center faq-item"
                @toggle="handleToggle($event, index)"
              >
                <summary
                  class="text-lg font-semibold text-brand cursor-pointer flex-1 flex justify-between items-start w-full"
                >
                  <span
                    ><span class="mr-2">{{ index + 1 }}.</span> {{ faq.question }}</span
                  >
                  <span class="ml-2 caret-icon transition-transform duration-300">›</span>
                </summary>
                <div class="accordion-content overflow-hidden">
                  <p
                    class="text-sm sm:text-md leading-relaxed text-justify mt-4 text-gray-500 w-full"
                    v-html="faq.answer"
                  ></p>
                </div>
              </details>
            </div>
            <div class="flex flex-col gap-4">
              <details
                v-for="(faq, index) in faqs.slice(7)"
                :key="`faq-right-${index}`"
                class="p-4 border-b flex flex-col justify-between items-center faq-item"
                @toggle="handleToggle($event, index + 7)"
              >
                <summary
                  class="text-lg font-semibold text-brand cursor-pointer flex-1 flex justify-between items-start w-full"
                >
                  <span
                    ><span class="mr-2">{{ index + 8 }}.</span> {{ faq.question }}</span
                  >
                  <span class="ml-2 caret-icon transition-transform duration-300">›</span>
                </summary>
                <div class="accordion-content overflow-hidden">
                  <p
                    class="leading-relaxed text-justify mt-4 text-gray-500 w-full"
                    v-html="faq.answer"
                  ></p>
                </div>
              </details>
            </div>
          </div>
        </div>
      </section>
      <section id="cta-section" class="bg-white px-4 sm:px-0">
        <div class="container mx-auto py-10 px-4 sm:px-0 max-w-5xl">
          <div
            class="w-full flex justify-center h-[2px] bg-brand rounded-full mb-10"
          ></div>
          <div
            class="bg-slate-100 rounded-xl shadow-md p-10 text-center max-w-3xl mx-auto"
          >
            <h2 class="text-2xl sm:text-3xl font-semibold text-brand mb-6">
              Sign Up For Your Weekly Email Reminder
            </h2>
            <NewsletterForm />
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { gsap } from "gsap";
import { useHead } from "#imports";
import Header from "~/components/Header.vue";
import Footer from "~/components/Footer.vue";
import PodcastCard from "~/components/PodcastCard.vue";
import heroImage from "~/assets/img/hero-edited.webp";
import meditationStance from "~/assets/img/meditation-stance.webp";
import SplitType from "split-type";
import ContactForm from "~/components/ContactForm.vue";
import NewsletterForm from "~/components/NewsletterForm.vue";
const user = await useSupabaseUser();
const supabase = useSupabaseClient();
const { data: audios } = await useFetchAudios();

const handleLogout = async () => {
  try {
    await supabase.auth.signOut();
    navigateTo("/login");
  } catch (error) {
    console.error("Error logging out:", error.message);
  }
};

useHead({
  title: "Meditation Circle - Free Weekly Guided Meditation",
  meta: [
    {
      name: "description",
      content:
        "Join our free weekly guided meditation and breathwork sessions. Find peace, clarity and community every Saturday."
    }
  ]
});

definePageMeta({
  layout: "default"
});

// FAQ data
const faqs = ref([
  {
    question: "Are these meditations really free?",
    answer:
      "Yes, completely free. Meditation has given us clarity, peace, and a way to process the noise of life, and we believe everyone should have access to that. This is our way of creating a space where people can come together, breathe, and reconnect with themselves without barriers.."
  },
  {
    question: "Why do you offer free guided meditations?",
    answer:
      "We created what we were missing in our own lives, a space to connect, process the chaos of the world, and find clarity through community. Meditation became our way to navigate uncertainty, release stress, and move through life with more ease. By offering these sessions, we invite others to join us in this practice, creating a shared experience of lightness, presence, and peace in a way that is accessible to everyone."
  },
  {
    question: "How do I join the meditation sessions?",
    answer:
      "Simply click the ZOOM link in the top right header of this page right before our call, or sign up for our reminder email list, and we will send you a link to join us on Zoom every Saturday at noon EST/EDT. No special equipment is needed, just a quiet space, a willingness to slow down, and an open heart. Click here to sign up for the email list."
  },
  {
    question: "Do I need any prior meditation experience to participate?",
    answer:
      "Not at all. Meditation is not about doing it right, it is about showing up and allowing yourself to be present. Whether you have never meditated before or have been practicing for years, these sessions will meet you where you are."
  },
  {
    question: "What should I expect during a guided meditation session?",
    answer:
      "Each session begins with a brief introduction from me and Effie, where we share the topic for the day and how it emerged from our own experiences throughout the week. These calls are not just about meditation but about processing life together, in real time, as a community. We believe in full transparency, so we take time to explain how the topic connects to the meditation and what to expect before we begin.<br><br>We guide you in preparing your space to create the best possible experience. Sometimes, I lead a short breathwork exercise (about 10 minutes) before Effie transitions into the main meditation (20-25 minutes). Other times, Effie starts the settling-in process, and I guide the main session. We alternate based on what resonates most during our weekly discussions.<br><br>After the meditation, we open the floor for a community sharing circle where guests can discuss their experiences, ask questions, or simply listen. These sessions are more than just guided meditations; they are a space for connection, reflection, and growth. Whether you choose to share or just absorb the energy of the group, you are always welcome."
  },
  {
    question: "Will the sessions be recorded if I can't attend live?",
    answer:
      "Yes, all sessions are recorded. To protect the privacy of our guests, we edit the recordings so they feel more like a podcast. The open share and Q&A portions are removed, leaving only the opening discussion and guided meditation for you to revisit at your convenience."
  },
  {
    question:
      "I've tried meditation before and it never seems to work for me. Why will this be different?",
    answer:
      'Many people struggle with meditation because they have been taught rigid systems that make them feel like they are doing it wrong from the start. While our practice takes inspiration from Transcendental Meditation, Zen, and Mindfulness Meditation, we have removed the barriers that demand perfection and keep people from experiencing real benefits.<br><br>Our approach is built on acceptance, guidance, and a deep understanding of the human psyche. We help you create moments of stillness and peace, even when your mind feels restless. There is no "right" way to meditate, but there are techniques that make it easier and more enjoyable. If you have struggled before, we will guide you in a way that actually works.'
  },
  {
    question: "How long do the sessions last?",
    answer:
      "Our live guided meditation circle typically lasts about 60 minutes. The recordings are shorter, as we remove the open share and Q&A portions to protect the privacy of our guests. Anthony's breathwork sessions typically last 10 to 15 minutes, while Effie's guided meditation journeys tend to last 20 to 25 minutes."
  },
  {
    question: "What should I bring or do to prepare for the meditation?",
    answer:
      "All you truly need is a quiet and comfortable place to sit. Some people light incense, sage, or candles, while others have an altar or a meaningful object nearby. It is entirely up to you, but the most important thing to bring is a willingness to explore stillness and silence."
  },
  {
    question: "Can I turn my camera off during the session?",
    answer:
      "Absolutely. We want you to feel comfortable and encourage you to turn off your camera during the meditation. Be sure to silence your phone and disable computer notifications for the best experience."
  },
  {
    question: "What if I join late?",
    answer:
      "Can I still participate? We allow late arrivals, but close the container once the meditation begins which is usually around the 12-15 minute mark. We do this to protect the sanctity of the circle and ensure there are no interruptions during the guided meditation."
  },
  {
    question: "Do I have to participate in the sharing circle at the end?",
    answer:
      "Not at all. Your presence is participation enough. Sharing is completely optional, and you are welcome to simply listen and absorb the experience."
  },
  {
    question: "Can I invite a friend to join?",
    answer:
      "Yes, we encourage you to invite a friend. Meditating with a buddy is a great way to build consistency and make the practice a habit. Starting something new takes time and commitment, and having a friend on the journey can make it even more meaningful."
  }
]);

// Add ref for animation in about section
const inView = ref(false);
const animatedSpan = ref(null);
const quoteText = ref(null);

// Intersection Observer to trigger animation when in view
onMounted(() => {
  if (process.client) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            inView.value = true;
            // Start typewriter animation after line appears
            setTimeout(() => {
              animateTypewriter();
            }, 1000); // Delay to allow the line to animate first
          }
        });
      },
      { threshold: 0.5 }
    );

    if (animatedSpan.value) {
      observer.observe(animatedSpan.value);
    }

    // Create a separate observer for featured mobile items
    const featuredItemsObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const item = entry.target;
            const icon = item.querySelector("#featured-mobile-item-icon");
            const title = item.querySelector("#featured-mobile-item-title");
            const description = item.querySelector("#featured-mobile-item-description");

            // Get the index of the item to calculate staggered delay
            const allItems = Array.from(
              document.querySelectorAll("#featured-mobile-item")
            );
            const itemIndex = allItems.indexOf(item);
            const staggerDelay = itemIndex * 0.15; // 0.15 seconds between each item start

            // Animate icon scale from 0 to 1
            gsap.fromTo(
              icon,
              { scale: 0, opacity: 0 },
              {
                scale: 1,
                opacity: 1,
                duration: 0.6,
                delay: staggerDelay,
                ease: "back.out(1.7)"
              }
            );

            // Animate title translating Y from -50% to 0%
            gsap.fromTo(
              title,
              { y: -50, opacity: 0 },
              {
                y: 0,
                opacity: 1,
                duration: 0.7,
                delay: staggerDelay + 0.4,
                ease: "power3.out"
              }
            );

            // Animate description with a staggered delay
            gsap.fromTo(
              description,
              { y: 30, opacity: 0 },
              {
                y: 0,
                opacity: 1,
                duration: 0.5,
                delay: staggerDelay + 0.6,
                ease: "power2.out"
              }
            );

            // Unobserve after animation is triggered
            featuredItemsObserver.unobserve(item);
          }
        });
      },
      { threshold: 0.2, rootMargin: "-50px" }
    );

    // Observe all featured mobile items
    document.querySelectorAll("#featured-mobile-item").forEach((item) => {
      featuredItemsObserver.observe(item);
    });

    // Create a separate observer for featured desktop items
    const featuredDesktopObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const item = entry.target;
            const icon = item.querySelector("#featured-desktop-item-icon");
            const title = item.querySelector("#featured-desktop-item-title");
            const description = item.querySelector("#featured-desktop-item-description");

            // Get the index of the item to calculate staggered delay
            const allItems = Array.from(
              document.querySelectorAll("#featured-desktop-item")
            );
            const itemIndex = allItems.indexOf(item);
            const staggerDelay = itemIndex * 0.2; // 0.2 seconds between each item start

            // Animate icon scale from 0 to 1
            if (icon) {
              gsap.fromTo(
                icon,
                { scale: 0, opacity: 0 },
                {
                  scale: 1,
                  opacity: 1,
                  duration: 1.2,
                  delay: staggerDelay,
                  ease: "elastic.out(1, 0.4)"
                }
              );
            }

            // Animate title sliding in from y-50% to y-0%
            if (title) {
              gsap.fromTo(
                title,
                { y: -50, opacity: 0 },
                {
                  y: 0,
                  opacity: 1,
                  duration: 1.0,
                  delay: staggerDelay + 0.5,
                  ease: "power3.out"
                }
              );
            }

            // Animate description if it exists
            if (description) {
              gsap.fromTo(
                description,
                { y: 30, opacity: 0 },
                {
                  y: 0,
                  opacity: 1,
                  duration: 0.8,
                  delay: staggerDelay + 0.8,
                  ease: "power2.out"
                }
              );
            }

            // Unobserve after animation is triggered
            featuredDesktopObserver.unobserve(item);
          }
        });
      },
      { threshold: 0.2, rootMargin: "-50px" }
    );

    // Observe all featured desktop items
    document.querySelectorAll("#featured-desktop-item").forEach((item) => {
      featuredDesktopObserver.observe(item);
    });
  }

  // Prevent automatic scrolling to hash fragment on initial page load
  if (window.location.hash) {
    // Delay to ensure the page is fully loaded
    setTimeout(() => {
      window.scrollTo(0, 0);
      // Optionally, remove the hash from URL without affecting history
      history.replaceState(null, "", window.location.pathname);
    }, 0);
  }

  // Split text animation for each hero word
  const heroWords = document.querySelectorAll(".hero-word");

  heroWords.forEach((word) => {
    // Use SplitType to split the text, but don't apply animation
    new SplitType(word, {
      types: "chars",
      tagName: "span"
    });
  });

  // Initialize accordion content heights
  document.querySelectorAll(".accordion-content").forEach((content) => {
    gsap.set(content, { maxHeight: 0, opacity: 0 });
  });
});

let currentOpenFaq = null;

const handleToggle = (event, index) => {
  const faqItem = event.target;
  const caretIcon = faqItem.querySelector(".caret-icon");
  const contentElement = faqItem.querySelector(".accordion-content");

  // Toggle the caret icon rotation
  if (faqItem.open) {
    gsap.to(caretIcon, { rotation: 90, duration: 0.3 });

    // Close previously open FAQ if it exists and is different from current
    if (currentOpenFaq !== null && currentOpenFaq !== index) {
      // Find all detail elements
      const allDetails = document.querySelectorAll("details.faq-item");
      // Close the previously open one
      if (allDetails[currentOpenFaq] && allDetails[currentOpenFaq].open) {
        allDetails[currentOpenFaq].open = false;
        const prevCaretIcon = allDetails[currentOpenFaq].querySelector(".caret-icon");
        gsap.to(prevCaretIcon, { rotation: 0, duration: 0.3 });
      }
    }

    // Animate content opening
    gsap.fromTo(
      contentElement,
      { maxHeight: 0, opacity: 0 },
      { maxHeight: "1000px", opacity: 1, duration: 0.5, ease: "power2.out" }
    );

    // Update current open FAQ
    currentOpenFaq = index;
  } else {
    gsap.to(caretIcon, { rotation: 0, duration: 0.3 });

    // Animate content closing
    gsap.to(contentElement, {
      maxHeight: 0,
      opacity: 0,
      duration: 0.5,
      ease: "power2.in"
    });

    // Reset current open FAQ if this was the open one
    if (currentOpenFaq === index) {
      currentOpenFaq = null;
    }
  }
};

// Function to animate the quote text with typewriter effect
const animateTypewriter = () => {
  if (!quoteText.value) return;

  const quoteLines = quoteText.value.querySelectorAll(".quote-line");
  if (!quoteLines.length) return;

  // Animate each line with staggered effect from left
  gsap.to(quoteLines, {
    x: 0,
    opacity: 1,
    duration: 0.8,
    stagger: 0.2,
    ease: "power3.out"
  });
};
</script>

<style scoped>
.hero-word {
  display: inline-block;
  margin-right: 0.2em;
  line-height: 1.1;
}

@media (max-width: 640px) {
  .hero-word {
    margin-bottom: 0.1em;
  }
}

/* Initial states for featured mobile items animations */
#featured-mobile-section #featured-mobile-item-icon {
  opacity: 0;
  transform: scale(0);
}

#featured-mobile-section #featured-mobile-item-title,
#featured-mobile-section #featured-mobile-item-description {
  opacity: 0;
}

/* Initial states for featured desktop items animations */
#featured-desktop-item-icon {
  opacity: 0;
  transform: scale(0);
}

#featured-desktop-item-title,
#featured-desktop-item-description {
  opacity: 0;
}

.faq-item summary {
  list-style: none;
  outline: none;
  position: relative;
  padding-right: 20px;
}

.faq-item summary::-webkit-details-marker {
  display: none;
}

.accordion-content {
  will-change: max-height, opacity;
}

.caret-icon {
  display: inline-block;
  font-size: 1.2rem;
  font-weight: bold;
  transform-origin: center;
  position: absolute;
  top: 4px;
  right: 0;
}

#split-text > span {
  display: inline-block;
}

.animate-expand {
  animation: expand-from-center 1.5s cubic-bezier(0.25, 0.1, 0.25, 1) forwards;
  height: 100%;
  transform-origin: center;
}

@keyframes expand-from-center {
  0% {
    transform: scaleY(0);
  }
  100% {
    transform: scaleY(1);
  }
}

.quote-line {
  will-change: transform, opacity;
}

@keyframes expand-from-center {
  0% {
    transform: scaleY(0);
  }
  100% {
    transform: scaleY(1);
  }
}
</style>
